import React from 'react';
import { RText } from './RText';

interface RErrorTextProps {
    children: React.ReactNode;
}

export function RErrorText({ children }: RErrorTextProps) {
    return (
        <RText size="sm" tone="error">
            {children}
        </RText>
    );
}
